const locale = {
  placeholder: '時刻を選択',
};

export default locale;
